module.exports = __webpack_public_path__ + "static/media/oberflex-aniegret6-1200x2490.c9c0ca75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aniegret6-1200x2490.jpg
// module id = 974
// module chunks = 37